import { Award, Medal, Trophy, Star } from "lucide-react";
import React, { useEffect, useState } from "react";
import Pagination from "../ui/Pagination";
import { Link } from "react-router-dom";
import { DriversSvg } from "../ui/SideBarMenu";
import { pluralize } from "../../helpers/general";

interface DriverData {
  user_id: string;
  fullName: string;
  profile_picture: string | null;
  total_rides: string;
  total_revenue: string;
  rating: string;
}

interface AllDriversListProps {
  drivers: DriverData[];
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  itemsPerPage: number;
  totalitems: number;
  search: string;
  onSearchChange: (search: string) => void;
}

const AllDriversList: React.FC<AllDriversListProps> = ({
  drivers,
  currentPage,
  totalPages,
  onPageChange,
  itemsPerPage,
  totalitems,
  search,
  onSearchChange,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <div className="d-flex justify-content-between mb-4">
        <div
          className="position-relative d-flex  gap-2 w-100"
          style={{ minWidth: "250px" }}
        >
          {/* <Search
            size={22}
            className="position-absolute text-muted z-3"
            style={{ left: "12px", top: "50%", transform: "translateY(-50%)" }}
          /> */}
          <input
            type="text"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            className={`form-control  py-0 px-3 rounded-3 shadow-sm  ${isMobile ? "w-75" : "w-25"}`}
            placeholder="Rechercher un chauffeur..."
          />
        </div>

        <div
          className={`d-flex align-items-end justify-content-center gap-3 bg-gradient-primary ${isMobile ? "p-1" : "p-3"}  rounded-3`}
          style={{ width: isMobile ? "35%" : "20%" }}
        >
          <DriversSvg className="fill-white my-auto" />
          <div
            className={`${isMobile ? "fs-6" : "fs-5"} fw-bold m-0  text-white text-pre `}
          >
            {totalitems} {pluralize("chauffeur", totalitems)}
          </div>
        </div>
      </div>
      {drivers.length > 0 ? (
        drivers.map((driver, index) => {
          const globalIndex = (currentPage - 1) * itemsPerPage + index;
          const getBorderColor = () => {
            if (globalIndex === 0) return "#f97722";
            if (globalIndex === 1) return "#c0c0c0";
            if (globalIndex === 2) return "#cd7f32";
            return "#dee2e6";
          };

          const getRankIcon = () => {
            if (globalIndex === 0)
              return <Trophy style={{ color: "#f97722" }} />;
            if (globalIndex === 1)
              return <Award style={{ color: "#c0c0c0" }} />;
            if (globalIndex === 2)
              return <Medal style={{ color: "#cd7f32" }} />;
            return null;
          };

          return (
            <div
              key={driver.user_id}
              className="position-relative w-100 rounded-4 p-4 bg-white d-flex align-items-center shadow-sm justify-between mb-3"
              style={{ border: `2px solid ${getBorderColor()}` }}
            >
              {/* Rank Icon */}
              <div
                className="position-absolute"
                style={{
                  top: "-10px",
                  right: "-10px",
                  background: "#fff",
                  borderRadius: "50%",
                  padding: "4px",
                  zIndex: 2,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                }}
              >
                {getRankIcon()}
              </div>
              <div className="d-flex align-items-start gap-3 w-100">
                {/* Avatar */}

                {/* Info */}
                <div>
                  <div className="fw-semibold text-dark d-flex align-items-center gap-2">
                    <div
                      className="rounded-circle overflow-hidden border border-secondary bg-light flex-shrink-0"
                      style={{
                        width: isMobile ? 40 : 50,
                        height: isMobile ? 40 : 50,
                      }}
                    >
                      {driver.profile_picture ? (
                        <img
                          src={driver.profile_picture}
                          alt={driver.fullName}
                          className="w-100 h-100 object-fit-cover"
                          style={{ borderRadius: "50%" }}
                        />
                      ) : (
                        <div className="w-100 h-100 d-flex align-items-center justify-content-center text-secondary fw-bold fs-5 text-uppercase">
                          {driver.fullName?.charAt(0)}
                        </div>
                      )}
                    </div>
                    <Link
                      to={`/drivers/${driver?.user_id}`}
                      className="fw-bold m-0 text-capitalize"
                    >
                      {driver?.fullName}
                    </Link>
                  </div>

                  <div
                    className={`d-flex mt-2 ${isMobile ? "gap-1" : "gap-3 ms-5"}`}
                  >
                    <div className="d-flex align-items-center gap-2 text-muted">
                      <img
                        src="/course.svg"
                        alt="courses"
                        width={isMobile ? 16 : 20}
                        height={isMobile ? 16 : 20}
                      />
                      <span style={{ fontSize: isMobile ? "12px" : "16px" }}>
                        {Number(driver.total_rides).toLocaleString()} Courses
                      </span>
                    </div>
                    <div className="d-flex align-items-center gap-2 text-muted">
                      <img
                        src="/money.svg"
                        alt="revenue"
                        width={isMobile ? 16 : 20}
                        height={isMobile ? 16 : 20}
                      />
                      <span style={{ fontSize: isMobile ? "12px" : "16px" }}>
                        {Number(driver.total_revenue).toLocaleString()} MAD
                      </span>
                    </div>
                    <div className="d-flex align-items-center gap-2 text-muted">
                      <Star fill="#f97722" strokeWidth={0} />
                      <span style={{ fontSize: isMobile ? "12px" : "16px" }}>
                        {driver.rating}/5.0 étoiles
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="d-flex justify-content-end">{getRankIcon()}</div> */}
            </div>
          );
        })
      ) : (
        <div className="d-flex justify-content-center align-items-center">
          <div className="text-muted">Aucun chauffeur trouvé</div>
        </div>
      )}

      {/* Pagination */}
      <div className="mt-4">
        <Pagination
          currentPage={currentPage}
          onPageChange={onPageChange}
          totalCount={totalPages}
          pageSize={itemsPerPage}
          siblingCount={1}
        />
      </div>
    </>
  );
};

export default AllDriversList;
